import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=da1f88e2&lang=less"
import "./App.vue?vue&type=style&index=1&id=da1f88e2&lang=less"

const __exports__ = script;

export default __exports__